import { useQuery } from '@tanstack/react-query';
import {
  GetOwnListWithdrawRequestEntity,
  WithdrawRequestService,
} from 'services/openapi';

import { RequestWithdrawQueryKeys } from '../constants';

type GetListRequestWithdrawOwnDTO = {
  transactionStatus: 'Tất cả' | 'Thành công' | 'Từ chối' | 'Đang xử lý';
  // transactionStatus: 'Thành công' | 'Từ chối' | 'Đang xử lý';
  transactionCode?: string;
  fromTime: string;
  toTime: string;
  page: string;
  pageSize: string;
  companyId?: string;
};

export const useGetRequestWithdrawOwnListExportQuery = (
  variables: Omit<GetListRequestWithdrawOwnDTO, 'transactionStatus'> & {
    transactionStatus: NonNullable<
      Parameters<
        typeof WithdrawRequestService.withdrawRequestControllerGetOwnList
      >[2]
    >;
  },
) => {
  const queryKey = [
    RequestWithdrawQueryKeys.GET_LIST_REQUEST_WITHDRAW_OWN,
    variables,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetOwnListWithdrawRequestEntity, Error>({
    queryKey: ['export', ...queryKey],
    queryFn: () =>
      WithdrawRequestService.withdrawRequestControllerGetOwnList(
        variables.fromTime?.trim(),
        variables.toTime?.trim(),
        variables.transactionStatus,
        variables.page,
        variables.pageSize,
        variables.companyId,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: false,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey: ['export', ...queryKey],
    refetch,
  };
};
